import { Center, HStack, Text } from '@chakra-ui/react';
import { UploadIcon } from './upload-icon';

export interface IRenderStyle {
  style: 'style_01' | 'style_02';
  handleClick: () => void;
  message?: string;
}

const dropZoneProps = {
  flexDirection: 'column',
  cursor: 'pointer',
  p: 'md',
  border: '1px',
  borderStyle: 'dashed',
  borderColor: 'gray.300',
  borderRadius: 'base',
} as const;

const DropHint = ({ mt }: { mt?: string }) => (
  <HStack spacing='xs' mt={mt}>
    <Text color='gray.700'>Drag & drop or</Text>
    <Text color='red.500'>click here</Text>
    <Text color='gray.700'>to upload</Text>
  </HStack>
);

export const StyleHandler = ({ style, handleClick, message }: IRenderStyle) => {
  switch (style) {
    case 'style_02':
      return (
        <Center onClick={handleClick} {...dropZoneProps} flex={1}>
          {!message && <DropHint />}
          {!!message && <Text color='gray.700'>{message}</Text>}
        </Center>
      );
    case 'style_01':
    default:
      return (
        <Center onClick={handleClick} {...dropZoneProps}>
          <UploadIcon />
          {!message && <DropHint mt='sm' />}
          {!!message && (
            <Text color='gray.700' mt='sm'>
              {message}
            </Text>
          )}
        </Center>
      );
  }
};
